const getters = {
    sidebar: state => state.app.sidebar,
    formula: state => state.app.formula,
    formula2: state => state.app.formula2,
    language: state => state.app.language,
    size: state => state.app.size,
    device: state => state.app.device,
    allList: state => state.user.allList,
    avatar: state => state.user.avatar, 
    name: state => state.user.name,
    defaultPath: state => state.user.defaultPath,
    token: state => state.user.token,
    introduction: state => state.user.introduction,
    roles: state => state.user.roles,
    rolesId: state => state.user.rolesId,
    addRouters: state => state.permission.addRouters,
    permission_routers: state => state.permission.routers,
    visitedViews: state => state.tagsView.visitedViews,
    cachedViews: state => state.tagsView.cachedViews,
    errorLogs: state => state.errorLog.logs,
    roleStatus: state => state.user.roleStatus,
}
export default getters